import { ListBlockConfig } from '@sequencehq/quote-content'
import { BlockAdapter } from 'modules/Cube/view/layouts/quote/QuoteEditorContent/ContentEditor/adapters/blocks/blockAdapter.types'

export const bulletListAdapter: BlockAdapter<'bulletListItem'> = {
  in: block => {
    return (block.config as ListBlockConfig).items.map(item => {
      return {
        type: 'bulletListItem',
        content: item
      }
    })
  },
  out: () => block => {
    return {
      blockType: 'bulletList',
      config: {
        items: block.content
          .filter(item => item.type === 'text' && item.text)
          .map(item => (item.type === 'text' ? item.text : ''))
      },
      version: 1
    }
  }
}
